import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import { Provider } from "react-redux";
import { store } from "./redux/store";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';

//======================|| APP ||=======================//
function App() {
  const content = useRoutes(router);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <ToastContainer />
        <Provider store={store}>
          {content}
        </Provider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
